import { useContext } from 'react';

import { UserContext } from 'shared/contexts/UserContext';

export const useUser = () => {
  return useContext(UserContext);
};
